import React, { Fragment } from 'react';

import { Price } from '../../components';
import { Icon } from 'antd';

interface Props {
    original: string | number;
    discounted: string | number;
    loading?: boolean;
}

export default function CartPrice({ original, discounted, loading }: Props) {
    function renderWithDifference() {
        return (
            <Fragment>
                <div className="cart-price-original">
                    <Price value={original} />
                </div>
                <div className="cart-price-discounted">
                    <Price value={discounted} />
                </div>
            </Fragment>
        );
    }

    function renderWithoutDifference() {
        return (
            <div className="cart-price-no-difference">
                <Price value={discounted} />
            </div>
        );
    }

    if (loading) {
        return (
            <div className="cart-price-loading">
                <Icon type="loading" className="font-grey" />
            </div>
        );
    }

    return (
        <div className="cart-price">
            {original > discounted ? renderWithDifference() : renderWithoutDifference()}
        </div>
    );
}
